var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-vertical-admin",
      attrs: { "default-active": "2", "active-text-color": "#ffd04b" },
      on: { open: _vm.handleOpen, close: _vm.handleClose }
    },
    [
      _c(
        "el-menu-item",
        { attrs: { index: "1-4" }, on: { click: _vm.addNewUniversity } },
        [
          _c("i", { staticClass: "el-icon-circle-plus" }),
          _c("span", [_vm._v("Διαχειριστικό Ιδρυμάτων (Νέων)")])
        ]
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1-3" }, on: { click: _vm.addUniversity } },
        [
          _c("i", { staticClass: "el-icon-circle-plus" }),
          _c("span", [_vm._v("Διαχειριστικό Ιδρυμάτων (Παλιών)")])
        ]
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1003" }, on: { click: _vm.toggleUniSearch } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-search" }),
            _c("span", [_vm._v("Αναζήτηση Ιδρυμάτων")])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c14d6066", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c14d6066","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/RegistryAdminMenu.vue
// module id = null
// module chunks = 